import { render, staticRenderFns } from "./MediaImageView.vue?vue&type=template&id=22f4ed07&scoped=true&"
import script from "./MediaImageView.vue?vue&type=script&lang=ts&"
export * from "./MediaImageView.vue?vue&type=script&lang=ts&"
import style0 from "./MediaImageView.vue?vue&type=style&index=0&id=22f4ed07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f4ed07",
  null
  
)

export default component.exports